export default {
  isOpenRoute (path, role, customerservicetag, moduletag) {
    // role: 'superadmin'-'超级管理者'，'admin'-'管理者'，'csd'-'客服'，'op'-'运营'，'company'-'服务商'，'guest'-'访客'，'sv'-'监管'
    // customerservicetag：1-客服，2-律师，3-外勤，4-话务+外勤
    // moduletag：1-居家，2-养老院 3-两者
    let flag = false
    // 养老院菜单开始
    if (path === '/roomManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/institutionStaff' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/oldPersonManagement' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/oldCardManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/nurseManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/dishesManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/menuManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/setMeal' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/orderSet' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/cashierDesk' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/rawMaterial' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/accommodationStatistics' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/checkInStatistics' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/awaitList' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/checkIn' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/leaveHospital' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/roomStatistics' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/bedStatistics' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/changeRecords' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/chargeItem' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/chargePrice' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/oldPersonStatistics' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    // if (path === '/healthDetection' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
    //   flag = true
    // }
    //  && moduletag === 2 开放到居家（除客服外）、养老院通用
    if (path === '/healthDetection') {
      if ((moduletag === 1 || moduletag === 3) && role !== 'csd') { // 除了客服不能看，其它都可以看
        flag = true
      } else if (moduletag === 2 && (role === 'superadmin' || role === 'admin' || role === 'csd')) {
        flag = true
      }
    }
    if (path === '/systemOperation' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/controlsRecords' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/changeService' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/outVisit' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/goodsEscrow' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/healthManage' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/buildingLayer' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/eventMonitor' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/siteMonitor' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/organizationInfo' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/deviceOrg' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/visitManagement' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/registInOut' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/deadlineWarn' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/serviceProject' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'guest') && moduletag === 2) {
      flag = true
    }
    if (path === '/serviceWorkOrder' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/rechargePay' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/financeStatistics' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/oldPersonCheck' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/weekSupply' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/weekMenu' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/foodEvidence' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/foodSafetyRecord' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    //  && moduletag === 2 开放到居家（除客服外）、养老院通用
    if (path === '/healthData') {
      if ((moduletag === 1 || moduletag === 3) && role !== 'csd') { // 除了客服不能看，其它都可以看
        flag = true
      } else if (moduletag === 2 && (role === 'superadmin' || role === 'admin' || role === 'csd')) {
        flag = true
      }
    }
    if (path === '/historyRecords' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/checkOutApprove' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/restaurantManagement' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/serviceRecord' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'guest') && moduletag === 2) {
      flag = true
    }
    if (path === '/dealAlarm' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/ingredientVendor' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/dataScreen' && (role === 'superadmin' || role === 'admin' || role === 'csd') && moduletag === 2) {
      flag = true
    }
    if (path === '/deviceStaff' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/deviceSupplier' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/faceDevice' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    // 养老院 居家都显示
    if (path === '/padDevice' && role === 'superadmin') {
      flag = true
    }
    if (path === '/orderRecord' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/medicationRegistration' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'guest') && moduletag === 2) {
      flag = true
    }
    if (path === '/todayReminder' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'guest') && moduletag === 2) {
      flag = true
    }
    if (path === '/dayWork' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'guest') && moduletag === 2) {
      flag = true
    }
    if (path === '/videoMonitor' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/safetyActivity' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/goodsMaterials' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/fixedAssets' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/doorRecord' && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    if (path === '/activityManagement' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if ((path === '/subsidyManagement' || path === '/feedback' || path === '/oldFeedBack') && (role === 'superadmin' || role === 'admin') && moduletag === 2) {
      flag = true
    }
    // 养老院菜单结束
    // 运营看板 1
    if (path === '/monitor' && (customerservicetag < 2 || customerservicetag === 4)) {
      flag = true
    }
    // 处理中心 2
    if (path === '/handleAlarm' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op')) {
      flag = true
    }
    if (path === '/customerService' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op') && (customerservicetag < 2 || customerservicetag === 4)) {
      flag = true
    }
    if (path === '/activeService' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op') && customerservicetag < 2) {
      flag = true
    }
    if (path === '/serviceOrder' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op') && customerservicetag < 2) {
      flag = true
    }
    if (path === '/supplierOrder' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op') && customerservicetag < 2) {
      flag = true
    }
    if (path === '/serviceSupplierOrder' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op') && customerservicetag < 2) {
      flag = true
    }
    if (path === '/examineOrder' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/servicePackage' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/serviceProjectBundle' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    /* 服务商 1 */
    if (path === '/serviceOrder' && role === 'company') {
      flag = true
    }
    if (path === '/supplierOrder' && role === 'company') {
      flag = true
    }
    // 系统管理
    /* 组织管理 4 */
    if (path === '/organization' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/user' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/account' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/SIPphone' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    /* 服务商管理 4 */
    if (path === '/serviceProvider' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/supplierType' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if ((path === '/serviceType' || path === '/supplierTypeService' || path === '/supplierContent') && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/serviceContent' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/serviceUser' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    /* 服务参数 2 */
    if (path === '/frequency' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/project' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }

    // 数据管理 5
    if (path === '/community' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/homeManagement' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/serviceObject' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/device' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/healthPage' && (role === 'superadmin' || role === 'admin' || role === 'op' || role === 'csd')) {
      flag = true
    }
    if (path === '/voiceNotification' && (role === 'superadmin' || role === 'admin' || role === 'op' || role === 'csd') && (customerservicetag < 2 || customerservicetag === 4)) {
      flag = true
    }
    if (path === '/deviceSet' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/deviceGroupChat' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/checkData' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/chargeReminder' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    // 报表统计 4
    if (path === '/alarmService' && (role === 'superadmin' || role === 'admin' || role === 'op' || role === 'csd' || role === 'sv')) {
      flag = true
    }
    if (path === '/serviceEvent' && (role === 'superadmin' || role === 'admin' || role === 'op' || role === 'csd' || role === 'company' || role === 'sv')) {
      flag = true
    }
    if (path === '/seatsOnline' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/callPhone' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/callInfo' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/otherStatistics' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/outworkStatistics' && (role === 'superadmin' || role === 'admin' || role === 'op')) {
      flag = true
    }
    if (path === '/companyOrder' && role === 'company') {
      flag = true
    }
    // 系统日志 5
    if (path === '/systemWork' && role === 'superadmin') {
      flag = true
    }
    if (path === '/loginLog' && role === 'superadmin') {
      flag = true
    }
    if (path === '/exportLog' && role === 'superadmin') {
      flag = true
    }
    if (path === '/systemOperation' && role === 'superadmin') {
      flag = true
    }
    if (path === '/systemError' && role === 'superadmin') {
      flag = true
    }
    if (path === '/stateRefillCard' && (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    if (path === '/deviceFactoryReset' && role === 'superadmin') {
      flag = true
    }
    if (path === '/deviceTest' && role === 'superadmin') {
      flag = true
    }
    if (path === '/videoZg' && (role === 'superadmin' || role === 'admin' || role === 'csd' || role === 'op')) {
      flag = true
    }
    if ((path === '/userManagement' || path === '/projectSet' || path === '/pointsSet' || path === '/pointsDetails') &&
      (role === 'superadmin' || role === 'admin')) {
      flag = true
    }
    return flag
  }
}



// WEBPACK FOOTER //
// ./src/common/routejs.js